import { User } from '@app/_models/_DTOs/user';
import { BaseDto } from '@app/_models/_DTOs/baseDto';
import { Employee } from '@app/_models/_DTOs/employee';
import { Asset } from '@app/_models/_DTOs/asset';
import { AssetHistory } from '@app/_models/_DTOs/assetHistory';
import { LocationType } from '@app/_models/enums/locationType';
import { LegalEntity } from './legalEntity';

export class Location extends BaseDto {
    type: LocationType;
    name: string;
    description: string;
    isDefaultForUnassigned: boolean;
    legalEntity: LegalEntity;
    personInCharge: Employee;
    assets: Asset[];
    employees: Employee[];
    assignedAssets: AssetHistory[];
    unassignedAssets: AssetHistory[];
    lastUpdatedBy: User;
}

export const LocationTypeName = new Map<LocationType, string>([
    [LocationType.Posebno, "Posebno"],
    [LocationType.Nedefinirano, "Nedefinirano"],
    [LocationType.Nepokretna, "Nepokretna"],
    [LocationType.Vozilo, "Vozilo"],
    [LocationType.Plovilo, "Plovilo"],
]);